// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../Members/MemberDetail.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.minor-member-detail-container { padding: 0; }

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.detail-title-area {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.worship-id-large {
  background: #e9ecef;
  color: #495057;
  font-family: 'Courier New', monospace;
  font-weight: 800;
  font-size: 1.6rem;
  padding: 6px 16px;
  border-radius: 8px;
  letter-spacing: 3px;
  min-width: 80px;
  text-align: center;
}

.detail-name { font-size: 1.5rem; font-weight: 700; margin: 0; }
.detail-eng-name { color: #6c757d; margin: 0; font-size: 0.9rem; }

.detail-actions { display: flex; gap: 8px; flex-wrap: wrap; }

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.25rem;
}

.detail-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
}

.family-card { grid-column: 1 / -1; }

.detail-card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 8px;
  margin-bottom: 12px;
}

.detail-field {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid #f3f4f6;
}
.detail-field:last-child { border-bottom: none; }
.detail-label { color: #6b7280; min-width: 120px; }
.detail-value { color: #111827; font-weight: 500; text-align: right; word-break: break-word; max-width: 200px; }

.detail-divider { border-top: 1px solid #e5e7eb; margin: 10px 0; }

.address-label { font-size: 0.8rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }

.badge-lg {
  font-size: 0.85rem;
  padding: 5px 12px;
  border-radius: 20px;
}

.badge-purple { background-color: #7c3aed; color: #fff; }
.badge-info { background-color: #0ea5e9; color: #fff; }
.text-success { color: #16a34a; font-weight: 600; }

/* ── Detail Tabs ─────────────────────────────────────────────────────────── */
.detail-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 1.25rem;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0;
}

.detail-tab-btn {
  background: none;
  border: none;
  padding: 9px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color .15s, border-color .15s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.detail-tab-btn:hover { color: #374151; background: #f9fafb; }
.detail-tab-btn.active { color: #1d4ed8; border-bottom-color: #1d4ed8; background: #fff; }

.detail-tab-badge {
  background: #e5e7eb;
  color: #374151;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}
.detail-tab-btn.active .detail-tab-badge { background: #dbeafe; color: #1d4ed8; }

/* ── Family Graph ─────────────────────────────────────────────────────────── */
.family-tree {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 8px 0 24px;
}

.family-level {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.family-level-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 10px;
  min-height: 16px;
}

.family-level-nodes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.family-connector-v {
  width: 2px;
  height: 32px;
  background: #d1d5db;
  margin: 4px 0;
  border-radius: 2px;
}

/* Family node card */
.family-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: #fff;
  border: 2px solid #d1d5db;
  border-radius: 10px;
  padding: 12px 16px;
  min-width: 100px;
  max-width: 140px;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
  text-align: center;
  transition: box-shadow .15s;
}
.family-node:hover { box-shadow: 0 4px 12px rgba(0,0,0,.1); }

.family-node-self {
  min-width: 120px;
  border-width: 2.5px;
  box-shadow: 0 2px 8px rgba(0,0,0,.10);
}

.family-node-relation {
  font-size: 0.72rem;
  font-weight: 700;
  background: #f3f4f6;
  color: #374151;
  padding: 2px 10px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.family-node-name {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
}

.family-node-worship {
  font-size: 0.72rem;
  color: #16a34a;
  font-weight: 700;
  background: #f0fdf4;
  padding: 1px 8px;
  border-radius: 10px;
}

.family-node-worship-id {
  font-family: 'Courier New', monospace;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 2px;
}

.family-others {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.family-legend {
  display: flex;
  gap: 20px;
  margin-top: 28px;
  font-size: 0.75rem;
  color: #6b7280;
}
.family-legend-church { color: #16a34a; }
.family-legend-other  { color: #9ca3af; }
`, "",{"version":3,"sources":["webpack://./src/components/MinorMembers/MinorMemberDetail.css"],"names":[],"mappings":"AAEA,iCAAiC,UAAU,EAAE;;AAE7C;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC/D,mBAAmB,cAAc,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAEjE,kBAAkB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE5D;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,eAAe,mBAAmB,EAAE;;AAEpC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;AACA,2BAA2B,mBAAmB,EAAE;AAChD,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD,gBAAgB,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE/G,kBAAkB,6BAA6B,EAAE,cAAc,EAAE;;AAEjE,iBAAiB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;;AAE5I;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gBAAgB,yBAAyB,EAAE,WAAW,EAAE;AACxD,cAAc,yBAAyB,EAAE,WAAW,EAAE;AACtD,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;;AAElD,+EAA+E;AAC/E;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;AAC7D,yBAAyB,cAAc,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;;AAEzF;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA,2CAA2C,mBAAmB,EAAE,cAAc,EAAE;;AAEhF,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,qBAAqB,qCAAqC,EAAE;;AAE5D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE","sourcesContent":["@import '../Members/MemberDetail.css';\n\n.minor-member-detail-container { padding: 0; }\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.detail-title-area {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.worship-id-large {\n  background: #e9ecef;\n  color: #495057;\n  font-family: 'Courier New', monospace;\n  font-weight: 800;\n  font-size: 1.6rem;\n  padding: 6px 16px;\n  border-radius: 8px;\n  letter-spacing: 3px;\n  min-width: 80px;\n  text-align: center;\n}\n\n.detail-name { font-size: 1.5rem; font-weight: 700; margin: 0; }\n.detail-eng-name { color: #6c757d; margin: 0; font-size: 0.9rem; }\n\n.detail-actions { display: flex; gap: 8px; flex-wrap: wrap; }\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.25rem;\n}\n\n.detail-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0,0,0,.05);\n}\n\n.family-card { grid-column: 1 / -1; }\n\n.detail-card-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 8px;\n  margin-bottom: 12px;\n}\n\n.detail-field {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 0;\n  font-size: 0.9rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n.detail-field:last-child { border-bottom: none; }\n.detail-label { color: #6b7280; min-width: 120px; }\n.detail-value { color: #111827; font-weight: 500; text-align: right; word-break: break-word; max-width: 200px; }\n\n.detail-divider { border-top: 1px solid #e5e7eb; margin: 10px 0; }\n\n.address-label { font-size: 0.8rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }\n\n.badge-lg {\n  font-size: 0.85rem;\n  padding: 5px 12px;\n  border-radius: 20px;\n}\n\n.badge-purple { background-color: #7c3aed; color: #fff; }\n.badge-info { background-color: #0ea5e9; color: #fff; }\n.text-success { color: #16a34a; font-weight: 600; }\n\n/* ── Detail Tabs ─────────────────────────────────────────────────────────── */\n.detail-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 1.25rem;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 0;\n}\n\n.detail-tab-btn {\n  background: none;\n  border: none;\n  padding: 9px 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 8px 8px 0 0;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: color .15s, border-color .15s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.detail-tab-btn:hover { color: #374151; background: #f9fafb; }\n.detail-tab-btn.active { color: #1d4ed8; border-bottom-color: #1d4ed8; background: #fff; }\n\n.detail-tab-badge {\n  background: #e5e7eb;\n  color: #374151;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 1px 6px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n.detail-tab-btn.active .detail-tab-badge { background: #dbeafe; color: #1d4ed8; }\n\n/* ── Family Graph ─────────────────────────────────────────────────────────── */\n.family-tree {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  padding: 8px 0 24px;\n}\n\n.family-level {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.family-level-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  margin-bottom: 10px;\n  min-height: 16px;\n}\n\n.family-level-nodes {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 16px;\n}\n\n.family-connector-v {\n  width: 2px;\n  height: 32px;\n  background: #d1d5db;\n  margin: 4px 0;\n  border-radius: 2px;\n}\n\n/* Family node card */\n.family-node {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  background: #fff;\n  border: 2px solid #d1d5db;\n  border-radius: 10px;\n  padding: 12px 16px;\n  min-width: 100px;\n  max-width: 140px;\n  box-shadow: 0 1px 4px rgba(0,0,0,.06);\n  text-align: center;\n  transition: box-shadow .15s;\n}\n.family-node:hover { box-shadow: 0 4px 12px rgba(0,0,0,.1); }\n\n.family-node-self {\n  min-width: 120px;\n  border-width: 2.5px;\n  box-shadow: 0 2px 8px rgba(0,0,0,.10);\n}\n\n.family-node-relation {\n  font-size: 0.72rem;\n  font-weight: 700;\n  background: #f3f4f6;\n  color: #374151;\n  padding: 2px 10px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n\n.family-node-name {\n  font-size: 0.9rem;\n  color: #111827;\n  font-weight: 500;\n}\n\n.family-node-worship {\n  font-size: 0.72rem;\n  color: #16a34a;\n  font-weight: 700;\n  background: #f0fdf4;\n  padding: 1px 8px;\n  border-radius: 10px;\n}\n\n.family-node-worship-id {\n  font-family: 'Courier New', monospace;\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: 2px;\n}\n\n.family-others {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px dashed #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.family-legend {\n  display: flex;\n  gap: 20px;\n  margin-top: 28px;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n.family-legend-church { color: #16a34a; }\n.family-legend-other  { color: #9ca3af; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
